export const categories = [
  {
    id: 1,
    slug: 'tech',
    name: '科技数码',
    description: '探索前沿科技，解读数码产品，掌握最新技术趋势',
    icon: 'ri-smartphone-line',
    articleCount: 128,
  },
  {
    id: 2,
    slug: 'entertainment',
    name: '娱乐影视',
    description: '热门影视综艺、明星动态、音乐演出资讯一网打尽',
    icon: 'ri-movie-2-line',
    articleCount: 256,
  },
  {
    id: 3,
    slug: 'lifestyle',
    name: '生活方式',
    description: '家居美学、时尚穿搭、个人成长，打造品质生活',
    icon: 'ri-heart-line',
    articleCount: 189,
  },
  {
    id: 4,
    slug: 'food-travel',
    name: '美食旅行',
    description: '舌尖上的世界，足迹丈量大地，分享美食与旅行故事',
    icon: 'ri-restaurant-line',
    articleCount: 145,
  },
  {
    id: 5,
    slug: 'health',
    name: '健康养生',
    description: '科学养生知识、运动健身指南、心理健康呵护',
    icon: 'ri-mental-health-line',
    articleCount: 97,
  },
  {
    id: 6,
    slug: 'finance',
    name: '财经商业',
    description: '经济趋势分析、投资理财干货、商业案例解读',
    icon: 'ri-funds-line',
    articleCount: 112,
  },
];